// extracted by mini-css-extract-plugin
export default {"visually_hidden":"PageSubTitle_visually_hidden__uNXva","box":"PageSubTitle_box__B8HKi"};